/*                                                        */
/*                                                  */
import { camelcasify } from "@otto-ec/assets-core-utils/string";

/**
 *
 *
 */
export const SHEET_EVENT_DOM_PREFIX = "oc-sheet";

export const defineSheetEvent = <T extends string>(
  eventName: T,
  legacyOpenClose: [api?: string, dom?: string][] = [],
  legacyContentChange: [api?: string, dom?: string][] = [],
) =>
  [
    camelcasify(eventName),
    `${SHEET_EVENT_DOM_PREFIX}-${eventName}`,
    legacyOpenClose,
    legacyContentChange,
  ] as const;

//
/*                 */
//
export const SHEET_EVENT_PRESENTATION_START = defineSheetEvent("presentation-start");

declare const SHEET_EVENT_PRESENTATION_START_API: (typeof SHEET_EVENT_PRESENTATION_START)[0];
declare const SHEET_EVENT_PRESENTATION_START_DOM: (typeof SHEET_EVENT_PRESENTATION_START)[1];
export type { SHEET_EVENT_PRESENTATION_START_API, SHEET_EVENT_PRESENTATION_START_DOM };

//
/*               */
//
export const SHEET_EVENT_PRESENTATION_END = defineSheetEvent("presentation-end");

declare const SHEET_EVENT_PRESENTATION_END_API: (typeof SHEET_EVENT_PRESENTATION_END)[0];
declare const SHEET_EVENT_PRESENTATION_END_DOM: (typeof SHEET_EVENT_PRESENTATION_END)[1];
export type { SHEET_EVENT_PRESENTATION_END_API, SHEET_EVENT_PRESENTATION_END_DOM };

//
/*          */
//
export const SHEET_EVENT_BEFORE_OPEN = defineSheetEvent(
  "before-open",
  [[undefined, "oc-before-open"]],
  [["beforeContentChange", "oc-before-content-change"]],
);

declare const SHEET_EVENT_BEFORE_OPEN_API: (typeof SHEET_EVENT_BEFORE_OPEN)[0];
declare const SHEET_EVENT_BEFORE_OPEN_DOM: (typeof SHEET_EVENT_BEFORE_OPEN)[1];
export type { SHEET_EVENT_BEFORE_OPEN_API, SHEET_EVENT_BEFORE_OPEN_DOM };

//
/*   */
//
export const SHEET_EVENT_OPEN = defineSheetEvent(
  "open",
  [[undefined, "oc-open"]],
  [
    ["switch", "oc-switch"],
    ["contentChangeShow", "oc-content-change-show"],
  ],
);

declare const SHEET_EVENT_OPEN_API: (typeof SHEET_EVENT_OPEN)[0];
declare const SHEET_EVENT_OPEN_DOM: (typeof SHEET_EVENT_OPEN)[1];
export type { SHEET_EVENT_OPEN_API, SHEET_EVENT_OPEN_DOM };

//
/*    */
//
export const SHEET_EVENT_FLYIN = defineSheetEvent("flyin");

declare const SHEET_EVENT_FLYIN_API: (typeof SHEET_EVENT_FLYIN)[0];
declare const SHEET_EVENT_FLYIN_DOM: (typeof SHEET_EVENT_FLYIN)[1];
export type { SHEET_EVENT_FLYIN_API, SHEET_EVENT_FLYIN_DOM };

//
/*         */
//
export const SHEET_EVENT_AFTER_OPEN = defineSheetEvent("after-open", [
  [undefined, "oc-after-open"],
]);

declare const SHEET_EVENT_AFTER_OPEN_API: (typeof SHEET_EVENT_AFTER_OPEN)[0];
declare const SHEET_EVENT_AFTER_OPEN_DOM: (typeof SHEET_EVENT_AFTER_OPEN)[1];
export type { SHEET_EVENT_AFTER_OPEN_API, SHEET_EVENT_AFTER_OPEN_DOM };

//
/*           */
//
export const SHEET_EVENT_BEFORE_CLOSE = defineSheetEvent("before-close", [
  [undefined, "oc-before-close"],
]);

declare const SHEET_EVENT_BEFORE_CLOSE_API: (typeof SHEET_EVENT_BEFORE_CLOSE)[0];
declare const SHEET_EVENT_BEFORE_CLOSE_DOM: (typeof SHEET_EVENT_BEFORE_CLOSE)[1];
export type { SHEET_EVENT_BEFORE_CLOSE_API, SHEET_EVENT_BEFORE_CLOSE_DOM };

//
/*    */
//
export const SHEET_EVENT_CLOSE = defineSheetEvent(
  "close",
  [[undefined, "oc-close"]],
  [["contentChangeHide", "oc-content-change-hide"]],
);

declare const SHEET_EVENT_CLOSE_API: (typeof SHEET_EVENT_CLOSE)[0];
declare const SHEET_EVENT_CLOSE_DOM: (typeof SHEET_EVENT_CLOSE)[1];
export type { SHEET_EVENT_CLOSE_API, SHEET_EVENT_CLOSE_DOM };

//
/*     */
//
export const SHEET_EVENT_FLYOUT = defineSheetEvent("flyout");
declare const SHEET_EVENT_FLYOUT_API: (typeof SHEET_EVENT_FLYOUT)[0];
declare const SHEET_EVENT_FLYOUT_DOM: (typeof SHEET_EVENT_FLYOUT)[1];
export type { SHEET_EVENT_FLYOUT_API, SHEET_EVENT_FLYOUT_DOM };

//
/*          */
//
export const SHEET_EVENT_AFTER_CLOSE = defineSheetEvent("after-close", [
  [undefined, "oc-after-close"],
]);

declare const SHEET_EVENT_AFTER_CLOSE_API: (typeof SHEET_EVENT_AFTER_CLOSE)[0];
declare const SHEET_EVENT_AFTER_CLOSE_DOM: (typeof SHEET_EVENT_AFTER_CLOSE)[1];
export type { SHEET_EVENT_AFTER_CLOSE_API, SHEET_EVENT_AFTER_CLOSE_DOM };

//
/*            */
//
export const SHEET_EVENT_CONTENT_FETCH = defineSheetEvent("content-fetch");

declare const SHEET_EVENT_CONTENT_FETCH_API: (typeof SHEET_EVENT_CONTENT_FETCH)[0];
declare const SHEET_EVENT_CONTENT_FETCH_DOM: (typeof SHEET_EVENT_CONTENT_FETCH)[1];
export type { SHEET_EVENT_CONTENT_FETCH_API, SHEET_EVENT_CONTENT_FETCH_DOM };

//
/*            */
//
export const SHEET_EVENT_CONTENT_PARSE = defineSheetEvent("content-parse");

declare const SHEET_EVENT_CONTENT_PARSE_API: (typeof SHEET_EVENT_CONTENT_PARSE)[0];
declare const SHEET_EVENT_CONTENT_PARSE_DOM: (typeof SHEET_EVENT_CONTENT_PARSE)[1];
export type { SHEET_EVENT_CONTENT_PARSE_API, SHEET_EVENT_CONTENT_PARSE_DOM };

//
/*            */
//
export const SHEET_EVENT_CONTENT_ERROR = defineSheetEvent("content-error", [
  ["contentLoadingError", "oc-content-loading-error"],
]);

declare const SHEET_EVENT_CONTENT_ERROR_API: (typeof SHEET_EVENT_CONTENT_ERROR)[0];
declare const SHEET_EVENT_CONTENT_ERROR_DOM: (typeof SHEET_EVENT_CONTENT_ERROR)[1];
export type { SHEET_EVENT_CONTENT_ERROR_API, SHEET_EVENT_CONTENT_ERROR_DOM };

//
/*            */
//
export const SHEET_EVENT_CONTENT_APPLY = defineSheetEvent("content-apply", [
  ["contentLoaded", "oc-content-loaded"],
]);

declare const SHEET_EVENT_CONTENT_APPLY_API: (typeof SHEET_EVENT_CONTENT_APPLY)[0];
declare const SHEET_EVENT_CONTENT_APPLY_DOM: (typeof SHEET_EVENT_CONTENT_APPLY)[1];
export type { SHEET_EVENT_CONTENT_APPLY_API, SHEET_EVENT_CONTENT_APPLY_DOM };

//
/*              */
//
export const SHEET_EVENT_CONTENT_DISCARD = defineSheetEvent("content-discard");

declare const SHEET_EVENT_CONTENT_DISCARD_API: (typeof SHEET_EVENT_CONTENT_DISCARD)[0];
declare const SHEET_EVENT_CONTENT_DISCARD_DOM: (typeof SHEET_EVENT_CONTENT_DISCARD)[1];
export type { SHEET_EVENT_CONTENT_DISCARD_API, SHEET_EVENT_CONTENT_DISCARD_DOM };
